import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { INewPort } from "../newportModel";

export const getAllNewPort = createAsyncThunk("Port/FindAllPort", async () => {
  try {
    const response = await axiosApiInstance.post(
      `${API_URL}/Port/FindAllPort`,
      {
        NewPortName: "",
      }
    );
    return response.data?.Data;
  } catch (error: any) {
    // ErrorToast(error?.response?.data?.Details || "Something went wrong");
    console.error("Error Fetching Newport:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const createNewPort = createAsyncThunk(
  "Port/InsertPort",
  async (NewPortData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Port/InsertPort`,
        NewPortData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Newport:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateNewPort = createAsyncThunk(
  "Port/UpdatePort",
  async (NewPortData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Port/UpdatePort`,
        NewPortData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating NewPort:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteNewPort = createAsyncThunk(
  "Port/DeletePort",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Port/DeletePort`,
        { port_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Newport:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getNewPortByID = createAsyncThunk(
  "Port/FindByIDPort",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Port/FindByIDPort`,
        { port_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        port_guid: result.port_guid,
        city_id: result.city_id,
        short_code: result.short_code,
        port_name: result.port_name,
        isactive: result.isactive === true ? 1 : 2,
      } as INewPort;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Newport:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveNewPort = createAsyncThunk(
  "Port/FindAllActivePort",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Port/FindAllActivePort`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Newport:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const newportActiveInactive = createAsyncThunk(
  "Port/ActiveInActivePort",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Port/ActiveInActivePort`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive port:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
